import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { listDokumen, listPerusahaan } from '../../Api';
import { fileBaseURL } from '../../Api';
import SkeletonLoader from '../../components/SkeletonLoader';


// Function to parse Indonesian date format (dd-MMM-yyyy) into JavaScript Date
const parseDateWithIndonesianMonth = (dateString) => {
  const months = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    Mei: "05",
    Jun: "06",
    Jul: "07",
    Agu: "08",
    Sep: "09",
    Okt: "10",
    Nov: "11",
    Des: "12",
  };

  const [day, month, year] = dateString.split("-");
  const normalizedMonth = months[month];
  if (!normalizedMonth) return null;

  return new Date(`${year}-${normalizedMonth}-${day}`);
};

function Document({ dateRange }) {
  const [documents, setDocuments] = useState(null);
  const [perusahaan, setPerusahaan] = useState(null);
  const [filteredDocuments, setFilteredDocuments] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState('ALL');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchOnceRef = useRef(false);
  const navigate = useNavigate();

  const fetchDocuments = async () => {
    setLoading(true);
    try {
      const data = await listDokumen();
      setDocuments(data);
    } catch (err) {
      setError('Failed to fetch documents');
    } finally {
      setLoading(false);
    }
  };

  const fetchPerusahaan = async () => {
    setLoading(true);
    try {
      const data = await listPerusahaan();
      setPerusahaan(data);
    } catch (err) {
      setError('Failed to fetch companies');
    } finally {
      setLoading(false);
    }
  };

  const filterDocuments = () => {
    if (!documents) return;

    if (!dateRange) {
      setFilteredDocuments(documents);
      return;
    }

    const today = new Date();
    const pastDate = new Date();
    pastDate.setDate(today.getDate() - dateRange);

    const filtered = {};
    Object.keys(documents).forEach((monthYear) => {
      const filteredItems = documents[monthYear].filter((item) => {
        const itemDate = parseDateWithIndonesianMonth(item.tgl_dokumen);
        return itemDate && itemDate >= pastDate && itemDate <= today;
      });

      if (filteredItems.length > 0) {
        filtered[monthYear] = filteredItems;
      }
    });

    setFilteredDocuments(filtered);
  };

  useEffect(() => {
    if (fetchOnceRef.current) return;
    fetchOnceRef.current = true;
    fetchDocuments();
    fetchPerusahaan();
  }, []);

  useEffect(() => {
    filterDocuments();
  }, [documents, dateRange]);

  const handleDocumentClick = (document) => {
    if (typeof document === 'undefined') return;

    const fileUrl = `${fileBaseURL}${document.nama_dokumen}`;
    if (document.nama_dokumen.endsWith('.pdf')) {
      navigate('/pdf-viewer', { state: { file: fileUrl } });
    } else {
      const link = window.document.createElement('a');
      link.href = fileUrl;
      link.download = document.nama_dokumen;
      link.click();
    }
  };

  // const handleRefresh = async () => {
  //   await fetchDocuments();
  // };

  return (
    <div className="dokumenpage">
      {loading ? (
        <div>
          <SkeletonLoader count={3} height={50} />
          <SkeletonLoader count={5} height={30} />
        </div>
      ) : error ? (
        <p>{error}</p>
      ) : (
        <>
          {perusahaan && (
            <div className="tabs-container">
              <button
                className={`tab-button ${selectedCompany === 'ALL' ? 'active' : ''}`}
                onClick={() => setSelectedCompany('ALL')}
              >
                Semua
              </button>
              {perusahaan.map((company) => (
                <button
                  key={company.id}
                  className={`tab-button ${selectedCompany === company.nama_perusahaan ? 'active' : ''}`}
                  onClick={() => setSelectedCompany(company.nama_perusahaan)}
                >
                  {company.nama_perusahaan}
                </button>
              ))}
            </div>
          )}

          {filteredDocuments && Object.keys(filteredDocuments).length === 0 ? (
            <p className="infotext">Anda Belum memiliki Dokumen</p>
          ) : (
            filteredDocuments &&
            Object.keys(filteredDocuments).map((monthYear) => {
              const companyFilteredItems = filteredDocuments[monthYear].filter(
                (item) =>
                  selectedCompany === 'ALL' ||
                  item.nama_perusahaan === selectedCompany
              );

              if (companyFilteredItems.length === 0) return null;

              return (
                <div key={monthYear} className="dokumen-group">
                  <h3 className="month-header">{monthYear}</h3>
                  <div className="item-list">
                    {companyFilteredItems.map((item, index) => (
                      <div key={`${item.id}-${index}`} className="item">
                        <div className="item-date">
                          <span className="item-day">{item.tgl_dokumen.split('-')[0]}</span>
                          <span className="item-month">{item.tgl_dokumen.split('-')[1]}</span>
                          <span className="item-year">{item.tgl_dokumen.split('-')[2]}</span>
                        </div>
                        <div className="item-content">
                          <p className="item-description">{item.nama_perusahaan}</p>
                          <h3
                            className="item-title"
                            onClick={() => handleDocumentClick(item)}
                            style={{ cursor: 'pointer' }}
                          >
                            {item.nama_dokumen}
                          </h3>
                          <p className="item-description">{item.size}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })
          )}
        </>
      )}
    </div>
  );
}

export default Document;
